<template>
  <div v-if="message" class="response-message" :class="type">
    <p v-html="message"></p>
  </div>
</template>

<script>
export default {
  name: 'ResponseMessage',
  props: {
    message: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'info',
      validator: value => ['success', 'error', 'info', 'warning'].includes(value)
    }
  }
};
</script>

<style scoped>
.response-message {
  margin-top: 20px;
  padding: 10px;
  text-align: center;
  border-radius: 5px;
  font-weight: bold;
}

.response-message.success {
  background-color: #d4edda;
  color: #155724;
}

.response-message.error {
  background-color: #f8d7da;
  color: #721c24;
}

.response-message.info {
  background-color: #d1ecf1;
  color: #0c5460;
}

.response-message.warning {
  background-color: #fff3cd;
  color: #856404;
}
</style>
